<template lang="pug">
  .task-skeleton-container
    .task-skeleton-module
      .task-skeleton-container
        SkeletonItem(className='task-skeleton-title')
        .task-skeleton-list
          .task-skeleton-list-item(v-for='i in 3')
            .task-skeleton-list-item-left
              SkeletonItem(className='task-skeleton-list-logo')
              .task-skeleton-item-info
                SkeletonItem(className='task-skeleton-info-name')
                SkeletonItem(className='task-skeleton-info-desc')
            .task-skeleton-list-item-right
              SkeletonItem(className='task-skeleton-item-btn')
        .task-skeleton-more-area
          SkeletonItem(className='task-skeleton-more')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'TaskSkeleton',
  components: {
    SkeletonItem,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.task-skeleton-module {
  margin-bottom: 0.08rem;
  padding: 0.16rem 0.12rem;
  width: 100%;
  background-color: #fff;
  border-radius: 0.12rem;
  box-sizing: border-box;

  &:last-child {
    margin-bottom: 0;
  }

  .task-skeleton-title {
    width: 1.38rem;
    height: 0.22rem;
  }

  .task-skeleton-list {
    margin-top: 0.14rem;
  }

  .task-skeleton-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.2rem;

    .task-skeleton-list-item-left {
      display: flex;
      align-items: center;
    }

    .task-skeleton-list-logo {
      margin-right: 0.12rem;
      width: 0.48rem;
      height: 0.48rem;
    }

    .task-skeleton-info-name {
      width: 1.74rem;
      height: 0.16rem;
    }

    .task-skeleton-info-desc {
      margin-top: 0.08rem;
      width: 0.88rem;
      height: 0.13rem;
    }

    .task-skeleton-item-btn {
      width: 0.63rem;
      height: 0.24rem;
      border-radius: 0.12rem;
    }
  }

  .task-skeleton-more-area {
    padding: 0.14rem 0 0;
  }

  .task-skeleton-more {
    margin: 0 auto;
    width: 0.88rem;
    height: 0.16rem;
  }
}
</style>
